import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
export default function DeleteButton(props: any) {
  return (
    <IconButton
      color="error"
      size="small"
      onClick={props.onClick}
    >
      <DeleteIcon />
    </IconButton>
  );
}
